/*
 * Forage minigame mushrooms — tiny critter-scale fungi the player walks over to collect.
 */

import { Container, Graphics } from 'pixi.js';
import type { ForageMushroom } from '@/state/types';

export interface MushroomFieldView {
  container: Container;
  /** Redraw all mushrooms from the latest state. */
  draw(mushrooms: readonly ForageMushroom[]): void;
}

export function createMushroomField(): MushroomFieldView {
  const root = new Container();
  const g = new Graphics();
  root.addChild(g);

  function draw(mushrooms: readonly ForageMushroom[]): void {
    g.clear();
    for (const m of mushrooms) {
      const s = m.scale;
      // Shadow.
      g.ellipse(m.x, m.y + 8 * s, 7 * s, 2 * s).fill({ color: 0x000000, alpha: 0.3 });
      // Stalk.
      g.ellipse(m.x, m.y + 4 * s, 4 * s, 7 * s).fill(0xfff4dc);
      // Cap.
      g.ellipse(m.x, m.y - 1 * s, 10 * s, 7 * s).fill(0xc9514c);
      // Cap shading.
      g.ellipse(m.x + 3 * s, m.y - 1 * s, 6 * s, 5 * s).fill({ color: 0x000000, alpha: 0.2 });
      // Cap dots.
      g.circle(m.x - 3 * s, m.y - 3 * s, 1.5 * s).fill(0xfff4dc);
      g.circle(m.x + 2 * s, m.y - 4 * s, 1.2 * s).fill(0xfff4dc);
    }
  }

  return { container: root, draw };
}
